import React from 'react';
import { EffectMarker, EFFECT_DEFINITIONS } from './types';

interface AddedEffectsPanelProps {
  effectMarkers: EffectMarker[];
  selectedEffectId: string | null;
  onSelectEffect: (id: string | null) => void;
  onRemoveEffect: (id: string) => void;
}

export function AddedEffectsPanel({ 
  effectMarkers, 
  selectedEffectId,
  onSelectEffect,
  onRemoveEffect 
}: AddedEffectsPanelProps) {
  const sortedEffects = [...effectMarkers].sort((a, b) => a.time - b.time);

  const handleRemove = (e: React.MouseEvent, effectId: string) => {
    e.stopPropagation();
    onRemoveEffect(effectId);
  };

  return (
    <div className="at-added-effects-panel-compact">
      <div className="at-added-effects-header">
        Добавленные эффекты
        <span className="at-effects-count">{effectMarkers.length}</span>
      </div>
      <div className="at-effects-list-compact">
        {sortedEffects.length === 0 ? (
          <div className="at-no-effects-compact">Нет добавленных эффектов</div>
        ) : (
          sortedEffects.map((effect) => {
            const def = EFFECT_DEFINITIONS.find((d) => d.id === effect.effectId);
            const isSelected = effect.id === selectedEffectId;
            return (
              <div
                key={effect.id}
                className={`at-effect-item-compact ${isSelected ? 'selected' : ''}`}
                onClick={() => onSelectEffect(isSelected ? null : effect.id)}
              >
                <div
                  className="at-effect-dot-compact"
                  style={{ backgroundColor: def?.color ?? '#888' }}
                />
                <span className="at-effect-code-compact">{effect.effectCode}</span>
                <span className="at-effect-time-compact">
                  {effect.time.toFixed(2)}s
                  {effect.params.duration ? ` (${effect.params.duration}s)` : ''}
                </span>
                <button
                  onClick={(e) => handleRemove(e, effect.id)}
                  className="at-remove-effect-btn-compact"
                  title="Удалить"
                >
                  ×
                </button>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
